
import styled from 'styled-components'
import {useDispatch, useSelector} from 'react-redux'
import { TopHeaderSettings } from './settings.styled'
import { useTranslation } from 'react-i18next'


export default function MyChurchDirectory() {
  const { t } = useTranslation('settings')

  // const { isdirectoryLoading, isDirectorySuccess, directoryList } = useSelector((state) => state.directory)
  const dispatch = useDispatch() 
  const { user } = useSelector((state) => state.auth)
  // useEffect(() => { dispatch(getDirectory()) }, [ ])

  return (
    <SettingsContainer>

    <TopHeaderSettings>{t('directoryItem.manage')}</TopHeaderSettings>

      {
        user.isPremium ? 
        (
          <div>
             {t('directoryItem.myDirectory')}
          </div> 
        )
        :
        (
          <div>
             {t('directoryItem.premiumRequired')}
          </div> 
        )
      }
    </SettingsContainer>
  )
}

const SettingsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

`
